export function Hero() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16 flex flex-col md:flex-row items-center md:space-x-12 space-y-8 md:space-y-0">
      <div className="flex-1">
        <span className="text-sm uppercase tracking-wider bg-gray-200 px-2 py-1 rounded-full text-gray-700">
          Ethos Tech Hub Limited
        </span>
        <h1 className="text-4xl md:text-5xl font-extrabold mt-4">
          Ethos | Smart Warehouse & Delivery
        </h1>
        <p className="mt-4 text-gray-600 text-lg">
          Revolutionize your supply chain with our comprehensive warehouse and delivery automation solution. 
          From intelligent stock management with barcode scanning to real-time delivery tracking and multi-warehouse 
          support — gain complete control over your inventory and distribution operations with end-to-end visibility.
        </p>
        
      </div>
      <div className="flex-1">
        <img
          src="/images/warehouse/warehouse.png" // Update image path
          alt="Smart Warehouse & Delivery Management Dashboard"
          className="w-64 mx-auto shadow-lg rounded-lg"
        />
      </div>
    </section>
  );
}